import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n.ts"; // ЭТА СТРОКА ОБЯЗАТЕЛЬНА!
import "../sentry.client.config"; // Initialize Sentry error logging
import { initWebVitals } from "./lib/web-vitals"; // Initialize Web Vitals monitoring
import { Toaster } from "@/components/ui/sonner";
import App from "./App.tsx";
import "./index.css";
import { TelegramProvider } from "./contexts/TelegramContext.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { HeaderProvider } from "./contexts/HeaderContext.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigurationProvider } from "./contexts/ConfigurationContext.tsx";

// CRITICAL: Initialize Telegram SDK BEFORE React mount (best practice)
// This ensures Telegram WebApp API is ready before any components try to use it
// Using @telegram-apps/sdk (not sdk-react) for v2.11.3 compatibility
import { init } from "@telegram-apps/sdk";

// Initialize Telegram SDK first (must be called before React mount)
try {
  init();
  console.log("[main.tsx] Telegram SDK initialized successfully");
} catch (error) {
  console.error("[main.tsx] Failed to initialize Telegram SDK:", error);
  // Continue anyway - app should work in browser for development
}

// Initialize performance monitoring
initWebVitals();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element with id 'root' not found in the document.");
}

try {
  console.log("[main.tsx] Attempting to render the application...");

  const queryClient = new QueryClient();

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <TelegramProvider>
          <AuthProvider>
            <ConfigurationProvider>
              <HeaderProvider>
                <App />
                <Toaster />
              </HeaderProvider>
            </ConfigurationProvider>
          </AuthProvider>
        </TelegramProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );

  console.log("[main.tsx] Application render initiated successfully.");
} catch (error) {
  console.error("[main.tsx] CRITICAL RENDER ERROR:", error);

  // ЭТОТ БЛОК ПОЙМАЕТ ОШИБКУ И ВЫВЕДЕТ ЕЕ НА ЭКРАН
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: monospace; color: #ff4d4d; background-color: #1a1a1a; min-height: 100vh;">
      <h1 style="font-size: 24px; margin-bottom: 20px;">Critical Application Error</h1>
      <p style="font-size: 16px; margin-bottom: 10px;">The application failed to start. This is a fatal JavaScript error.</p>
      <div style="background-color: #333; padding: 15px; border-radius: 5px;">
        <pre style="white-space: pre-wrap; word-wrap: break-word;"><strong>Error Message:</strong>\n${(error as Error).message}</pre>
        <hr style="border-color: #555; margin: 15px 0;" />
        <pre style="white-space: pre-wrap; word-wrap: break-word;"><strong>Stack Trace:</strong>\n${(error as Error).stack}</pre>
      </div>
    </div>
  `;
}
